export const FLIGHT_NOTIFICATIONS = 'FLIGHT_NOTIFICATIONS'
export const FLIGHT_DELAY_PROTECTION = 'FLIGHT_DELAY_PROTECTION'
export const LUGGAGE_PROTECTION = 'LUGGAGE_PROTECTION'
export const AUTO_CHECKIN = 'AUTO_CHECKIN'
export const TRIPADD = 'TRIPADD'
export const insuranceTypes = [FLIGHT_NOTIFICATIONS, FLIGHT_DELAY_PROTECTION, LUGGAGE_PROTECTION, AUTO_CHECKIN]
